import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Input, Button, Row, Col, message } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import image from "../assets/auth/auth_cover.jpeg";
import { BASE_URL, SUB_URL } from "../services/BaseUrl";
import ResponseMessage from "../components/Comman/Notification/ResponseMessge";

function UserAuth({ onLoginSuccess }) {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();


    // const handleNavigation = (dept) => {
    //     switch (dept) {
    //         case "22":
    //             navigate("/wash/dashboard");
    //             break;
    //         case "20":
    //             navigate("/eol-dashboard");
    //             break;
    //         case "21":
    //             navigate("/manage-bin");
    //             break;
    //         case "23":
    //             navigate("/gsm/bin/dashboard")
    //             break;
    //         case "24":
    //             navigate("/kca/dashboard")
    //             break;
    //         case "11":
    //             navigate("/eolc/dashboard")
    //             break;
    //         default:
    //             navigate("/user-not-allow");
    //     }
    // };
    const handleNavigation = (dept) => {
    switch (dept) {
        case "22":
            navigate("/wash/dashboard");
            break;
        case "20":
            navigate("/eol-dashboard");
            break;
        case "21":
            navigate("/manage-bin");
            break;
        case "23":
            navigate("/gsm/bin/dashboard");
            break;
        case "24":
            navigate("/kca/dashboard");
            break;
        case "11":
            navigate("/eolc/dashboard");
            break;
        case "18":  // ✅ FIX ADDED
            navigate("/tlsreport/rovingqcreport");
            break;

        default:
            navigate("/user-not-allow");
    }
};


    useEffect(() => {
        const checkLoginStatus = async () => {
            try {
                const storedUserData = localStorage.getItem("userData");
                const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
    
                if (isLoggedIn && storedUserData) {
                    const parsedData = JSON.parse(storedUserData);
    
                    if (parsedData && parsedData.data && parsedData.data.dept) {
                        onLoginSuccess(parsedData);
                        handleNavigation(parsedData.data.dept);
                    } else {
                        localStorage.clear();
                        navigate("/");
                    }
                } else {
                    // If not logged in, always redirect to "/"
                    navigate("/");
                }
            } catch (error) {
                console.error("Error parsing localStorage data:", error);
                localStorage.clear();
                navigate("/");
            }
        };
    
        checkLoginStatus();
    }, [navigate, onLoginSuccess]);

    const handleLogin = async () => {
        try {
            const formData = new FormData();
            formData.append("username", username);
            formData.append("password", password);

            const response = await fetch(
                `${BASE_URL.BASE_URL}${BASE_URL.API_URL}${SUB_URL.login}`,
                {
                    method: "POST",
                    body: formData,
                }
            );

            if (response.ok) {
                const data = await response.json();

                if (data.status) {
                    localStorage.setItem("userData", JSON.stringify(data));
                    localStorage.setItem("isLoggedIn", "true");

                    onLoginSuccess(data);
                    handleNavigation(data.data.dept);
                    ResponseMessage.success(data.message || "Login successful!");
                } else {
                    console.error("Error Message:", data.message);
                    ResponseMessage.error(data.message || "Invalid username or password.");
                }
            } else {
                console.error("HTTP Error:", response.status);
                ResponseMessage.error("Server error. Please try again later.");
            }
        } catch (error) {
            console.error("Error during login:", error);
            ResponseMessage.error("An error occurred. Please check your connection and try again.");
        }
    };

    const styles = {
        container: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            backgroundColor: "#f0f2f5",
        },
        form: {
            padding: "20px",
            background: "white",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            maxWidth: "600px",
            width: '100%',
        },
        title: {
            fontSize: "18px",
            fontWeight: "bold",
            marginTop: '3px',
            marginBottom: "10px",
            paddingLeft: "5px",
        },
        button: {
            width: "100%",
        },
        imageContainer: {
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        image: {
            width: "100%",
            maxWidth: "100%",
            height: "auto",
            objectFit: "cover",
            borderRadius: "8px",
        },
        header: {
            marginTop: '0px',
            paddingLeft: "20px",
            paddingTop: "20px",
            fontSize: "24px",
            fontWeight: "bold",
        },
    };

    return (
        <Row gutter={16} style={{ height: "100vh" }}>
            <Col xs={0} sm={12} md={12} lg={12} xl={12}>
                <div style={styles.imageContainer}>
                    <img src={image} alt="background" style={styles.image} />
                </div>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={12} style={styles.container}>
                <div>
                    <Form
                        name="login_form"
                        style={styles.form}
                        onFinish={handleLogin}
                    >
                        <div style={styles.title}>Staff Login</div>
                        <Form.Item
                            name="username"
                            rules={[
                                {
                                    required: true,
                                    message: "Please input your Username!",
                                },
                            ]}
                        >
                            <Input
                                size="large"
                                prefix={<UserOutlined />}
                                placeholder="Username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                            />
                        </Form.Item>
                        <Form.Item
                            name="password"
                            rules={[
                                {
                                    required: true,
                                    message: "Please input your Password!",
                                },
                            ]}
                        >
                            <Input
                                size="large"
                                prefix={<LockOutlined />}
                                type="password"
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </Form.Item>
                        <Form.Item>
                            <Button size="large" type="primary" htmlType="submit" style={styles.button}>
                                Log in
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </Col>
        </Row>
    );
}

export default UserAuth;